import dayjs from "dayjs";

export const percentFormatter = (params) => {
  if (params.value !== undefined && params.value !== null) {
    return params.value.toFixed(2) + "%";
  }
};

export const percent1Formatter = (params) => {
  if (params.value !== undefined && params.value !== null) {
    if (typeof params.value === "number") {
      return Number(params.value).toFixed(1) + "%"
    }
    return Number(params.value.split(";")[0]).toFixed(1) + "%";
  }
};

export const percent0Formatter = (params) => {
  if (params.value !== undefined && params.value !== null) {
    return params.value.toFixed(0) + "%";
  }
};

export const currencyFormatter = (params) => {
  if (params.value !== undefined && params.value != null) {
    if (typeof params.value === "number") {
      return "$" + formatNumber(params.value)
    }
    return "$" + formatNumber(params.value.split(";")[0]);
  }
};

export const yearFormatter = (params) => {

  if (params.value !== undefined && params.value !== null) {
    if (typeof params.value === "number") {
      return params.value
    }
    return params.value.split(";")[0];
  }
};


export const ageFormatter = (params) => {

  if (params.value !== undefined && params.value !== null) {
    if (typeof params.value === "number") {
      return params.value
    } else if (typeof params.value === "string") {
      return params.value.split(";")[0];
    }
    else {
      return 0
    }
  }
};


export const moneyFormatter = (params) => {
  if (params.value !== undefined && params.value !== null) {
    return "$" + formatNumber(params.value);
  }
};
export const moneyPennyFormatter = (params) => {
  if (params.value !== undefined && params.value !== null) {
    return "$" + formatPennyNumber(params.value);
  }
};

export const upToAgeFormatter = (params) => {
  if (params.value !== undefined && params.value !== null) {
    if (params.data !== null && params.data.Repeat !== null && params.data.Repeat > 1) {
      return String(params.value) + "/" + params.data.Repeat

    } else {
      return params.value
    }
  }
};
const currencyFormatter_nosym = (params) => {
  if (params.value !== undefined && params.value !== null) {
    return formatNumber(params.value);
  }
};

export const formatNumber = (number) => {
  // this puts commas into the number eg 1000 goes to 1,000,
  // i pulled this from stack overflow, i have no idea how it works
  return Math.floor(number)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const formatPennyNumber = (number) => {
  // this puts commas into the number eg 1000 goes to 1,000,
  // i pulled this from stack overflow, i have no idea how it works
  return number.toFixed(2)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
export const timeFormatter = (params) => {
  if (params.value !== null) {
    let d = new dayjs(params.value);
    return d.format("D-MMM-YYYY") + "  " + d.format("H:mm");
  }
  return ""
};

export const WhoWhenFormatter = (params) => {
  let combo = ""
  if (params.value !== null) {
    let d = new dayjs(params.value.When);
    let td = d.format("D-MMM-YYYY") + "  " + d.format("H:mm");
    combo = td + "    " + params.value.Who
  }

  return combo
}
